declare global {
  interface Window {
    dataLayer: any;
  }
}

export interface UmbracoABTestModel {
  name: string;
  control: string;
  variants: string[];
}

interface PushABTestExperienceImpression {
  currentVariant: string;
  abTest?: UmbracoABTestModel;
}

const pushABTestExperienceImpression = (input?: PushABTestExperienceImpression) => {
  if (!input?.abTest) {
    return;
  }
  window.dataLayer = window.dataLayer || [];

  const { currentVariant, abTest } = input;
  const { control, name } = abTest;
  const testName = dashToUnderScore(name);
  const variantName = control === currentVariant ? "control" : resolveNameFromVariantPath(currentVariant, 4);
  window.dataLayer.push({
    event: "GAEvent",
    GA4EventName: "experience_impression",
    GA4InputFieldName1: "exp_variant_string",
    GA4InputFieldValue1: `internal-${testName}-${variantName}`,
  });
};

export const pushVirtualPageView = (
  title: string,
  navigationType: "first_load" | "spa_navigation",
  abTest?: PushABTestExperienceImpression,
) => {
  const { pathname, search, hash } = window.location;
  const urlInBrowser = `${pathname}${search}${hash}`;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "virtual_pageview",
    virtualPagePath: urlInBrowser,
    virtualPageTitle: title,
    virtualNavigation: navigationType,
  });
  pushABTestExperienceImpression(abTest);
};

function resolveNameFromVariantPath(str: string, index: number) {
  const splitStr = str.split("/");
  if (index < splitStr.length) {
    return dashToUnderScore(splitStr[index]);
  } else {
    return "unknown";
  }
}

function dashToUnderScore(input) {
  return input?.replace(/-/g, "_") ?? "";
}
